import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="users--user"
export default class extends Controller {
  static targets = ["table"]

  edit(event) {
    const row = event.currentTarget;
    const url = row.dataset.editUrl;
    Turbo.visit(url, { frame: 'user-form' });
    this.resetSelectedEntry();
    row.classList.add('selected');
  }

  resetSelectedEntry() {
    this.tableTarget
        .querySelectorAll('tr')
        .forEach(tr => tr.classList.remove('selected'));
  }
}
